 
import { Col, Row } from 'react-bootstrap';
import StatisticsCard from './StatisticsCard';
import bg1 from '@/assets/img/icons/spot-illustrations/corner-1.png';
import bg2 from '@/assets/img/icons/spot-illustrations/corner-2.png';
import bg3 from '@/assets/img/icons/spot-illustrations/corner-3.png';
import bg4 from '@/assets/img/icons/spot-illustrations/corner-4.png';


const StatisticsCards = () => {
  const statsData = [
    {
      title: 'کلمات کلیدی',
      value: 230,
      decimal: false,
      suffix: '',
      prefix: '',
      valueClassName: 'text-warning',
      badgeBg: 'warning',
      badgeText: '',
      link: '/e-commerce/customers',
      linkText: null,
      image: bg1
    },
    {
      title: 'میانگین رتبه',
      value: 23.43,
      decimal: true,
      suffix: '',
      prefix: 'up',
      valueClassName: 'text-info',
      badgeBg: 'info',
      badgeText: '0.0%',
      link: '/e-commerce/orders/order-list',
      linkText: null,
      image: bg2
    },
    {
      title: 'SOV',
      value: 43594,
      decimal: false,
      suffix: '',
      prefix: 'down',
      valueClassName: '',
      badgeBg: 'success',
      badgeText: '9.54%',
      link: '/',
      linkText:null,
      image: bg3
    },
    {
      title: 'E traffic',
      value: 43594,
      decimal: false,
      suffix: '',
      prefix: 'up',
      valueClassName: '',
      badgeBg: 'success',
      badgeText: '9.54%',
      link: '/',
      linkText:null,
      image: bg4
    }
  ];
  return (
    <Row className="g-3">
      {statsData.map((stat, index) => (
        <Col key={stat.title} sm={index === 2 ? 12 : 6} md={3}>
          <StatisticsCard stat={stat} style={{ minWidth: '12rem' }} />
        </Col>
      ))}
    </Row>
  );
};

export default StatisticsCards;
